import { PARTNER_CONFIG } from '#client/constants/partnerConfig';

// TODO: replace stub with real partner entity detection from business entity GQL field
// Set IS_PARTNER_STUB = true to test the Squarespace partner experience locally
const IS_PARTNER_STUB = false;

export function usePartnerEntity() {
  // Phase 2: read enterprise_id (non-null = is partner) and enterprise_partner_uuid
  // (identifies which partner) from the business entity, then look up PARTNER_CONFIG
  const partner = IS_PARTNER_STUB ? { id: 'squarespace', ...PARTNER_CONFIG.squarespace } : null;
  // mocking the true for local testing

  return {
    isPartner: Boolean(partner),
    partner,
    loading: false
  };
}
